import { registerBlockType } from "@wordpress/blocks";
import { button as icon } from "@wordpress/icons";
import metadata from "./block.json";
import "./style.scss";
import Edit from "./Edit";

registerBlockType(metadata.name, {
  edit: Edit,
  save: () => null,
  icon: {
    foreground: "#0061FE",
    src: icon,
  },
});
